import { DollarSign, MessageSquare } from "lucide-react";
import type { ReactNode } from "react";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";
import { SIDEBAR_VIEW, type SidebarView } from "./sidebar-view";

export const SidebarViewToggle = ({
  view,
  onViewChange,
}: {
  view: SidebarView;
  onViewChange: (view: SidebarView) => void;
}) => {
  const option = (value: SidebarView, label: string, icon: ReactNode) => {
    const active = view === value;

    return (
      <button
        type="button"
        aria-pressed={active}
        onClick={() => onViewChange(value)}
        className={cn(
          "flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          {
            "bg-surface-primary text-primary-text shadow-sm": active,
            "text-secondary-text hover:text-primary-text": !active,
          },
        )}
      >
        {icon}
        {label}
      </button>
    );
  };

  return (
    <Stack
      direction="row"
      gap="none"
      className="shrink-0 rounded-lg bg-surface-secondary p-0.5"
    >
      {option(SIDEBAR_VIEW.preview, "Pay", <DollarSign className="h-4 w-4" />)}
      {option(
        SIDEBAR_VIEW.history,
        "Notes & history",
        <MessageSquare className="h-4 w-4" />,
      )}
    </Stack>
  );
};
